export const GOOGLE_FONT_FAMILY_PATTERN = /^[A-Za-z0-9 ]+$/;

export const GOOGLE_FONT_FAMILIES = [
  'Abel',
  'Albert Sans',
  'Alegreya',
  'Alegreya Sans',
  'Anton',
  'Archivo',
  'Archivo Narrow',
  'Arimo',
  'Arvo',
  'Asap',
  'Assistant',
  'Atkinson Hyperlegible',
  'Barlow',
  'Barlow Condensed',
  'Be Vietnam Pro',
  'Bebas Neue',
  'Bitter',
  'Bricolage Grotesk',
  'Cabin',
  'Cairo',
  'Cardo',
  'Catamaran',
  'Cormorant Garamond',
  'Crimson Pro',
  'Crimson Text',
  'DM Sans',
  'DM Serif Display',
  'DM Serif Text',
  'Dosis',
  'EB Garamond',
  'Epilogue',
  'Exo 2',
  'Figtree',
  'Fira Sans',
  'Fraunces',
  'Geist',
  'Heebo',
  'Hind',
  'IBM Plex Mono',
  'IBM Plex Sans',
  'IBM Plex Serif',
  'Inconsolata',
  'Instrument Sans',
  'Inter',
  'Josefin Sans',
  'Josefin Slab',
  'Jost',
  'Karla',
  'Lato',
  'Lexend',
  'Libre Baskerville',
  'Libre Franklin',
  'Literata',
  'Lora',
  'Manrope',
  'Merriweather',
  'Montserrat',
  'Mukta',
  'Mulish',
  'Newsreader',
  'Noto Sans',
  'Noto Serif',
  'Nunito',
  'Nunito Sans',
  'Onest',
  'Open Sans',
  'Oswald',
  'Outfit',
  'Overpass',
  'Playfair Display',
  'Plus Jakarta Sans',
  'Poppins',
  'PT Sans',
  'PT Serif',
  'Public Sans',
  'Questrial',
  'Quicksand',
  'Rajdhani',
  'Raleway',
  'Red Hat Display',
  'Red Hat Text',
  'Roboto',
  'Roboto Condensed',
  'Roboto Mono',
  'Roboto Slab',
  'Rubik',
  'Schibsted Grotesk',
  'Signika',
  'Sora',
  'Source Code Pro',
  'Source Sans 3',
  'Source Serif 4',
  'Space Grotesk',
  'Space Mono',
  'Spectral',
  'Titillium Web',
  'Ubuntu',
  'Urbanist',
  'Work Sans',
  'Zilla Slab'
] as const;

export type GoogleFontFamily = (typeof GOOGLE_FONT_FAMILIES)[number];

export const GOOGLE_FONT_FAMILY_OPTIONS = GOOGLE_FONT_FAMILIES.map(
  (family) => ({
    label: family,
    value: family
  })
);
